import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpApiService} from './http-api.service';
import {ReservationDetails} from "../../models/reservation_details.model";
import {Taux} from "../../models/contract.model";

@Injectable({
  providedIn: 'root'
})
export class PlanningApiService {
  private readonly addReservationEndpoint = 'planning/add_reservation';
  private readonly getReservationEndpoint = 'planning/get_reservation';
  private readonly updateTransportEndpoint = 'planning/update_transport';
  private readonly changeReservationDateEndpoint = 'planning/change_reservation_date';
  private readonly saveTauxEndpoint = 'planning/save_taux';
  private readonly changeVersionEndpoint = 'planning/change_version';
  private readonly validateTransportEndpoint = 'planning/validate_transport';
  private readonly updateLoanContractEndpoint = 'planning/update_loan_contract';
  private readonly updateContractInfosEndpoint = 'planning/update_contract_infos';
  private readonly setHeureAvpEndpoint = 'planning/set_heure_avp';


  constructor(private httpApiService: HttpApiService) {
  }

  public addReservation(cookies: string, params: any): Observable<any> {
    return this.httpApiService.post<any>(this.addReservationEndpoint, params, cookies);
  }

  public getReservation(cookies: string, idReservation: number): Observable<ReservationDetails> {
    return this.httpApiService.get<any>(this.getReservationEndpoint, {'id_reser': idReservation}, cookies);
  }

  public updateTransport(cookies: string, params: any): Observable<ReservationDetails> {
    return this.httpApiService.post<any>(this.updateTransportEndpoint, params, cookies);
  }

  public changeReservationDate(cookies: string, idReservation: number, newDate: string, whichDate: string): Observable<any> {
    const params = {
      id_reser: idReservation,
      new_date: newDate,
      which_date: whichDate

    };
    return this.httpApiService.post<any>(this.changeReservationDateEndpoint, params, cookies);
  }

  public updateTaux(cookies: string, taux: any): Observable<any> {
    const params = {list_taux: taux}
    return this.httpApiService.post<any>(this.saveTauxEndpoint, params, cookies);
  }

  public changeVersion(cookies: string, idVersion: number, idReservation: number, checked: boolean): Observable<any> {
    const params = {
      id_ver: idVersion,
      id_reser: idReservation,
      checked: checked

    };
    return this.httpApiService.post<any>(this.changeVersionEndpoint, params, cookies);
  }

  public validateTransport(cookies: string, idTransport: number): Observable<any> {
    const params = {
      id_transport: idTransport,
    };
    return this.httpApiService.post<any>(this.validateTransportEndpoint, params, cookies);
  }

  public updateLoanContract(cookies: string, id_contract: number, id_reser: number): Observable<any> {
    const params = {
      id_contract: id_contract,
      id_reser: id_reser,

    };
    return this.httpApiService.post<any>(this.updateLoanContractEndpoint, params, cookies);
  }

  public updateContractInfos(cookies: string, params: any): Observable<any> {
    return this.httpApiService.post<any>(this.updateContractInfosEndpoint, params, cookies);
  }

  public setAvpHour(cookies: string, id_reser: number, heure_avp: string): Observable<any> {
    const params = {
      id_reser: id_reser,
      heure_avp: heure_avp,

    };
    return this.httpApiService.post<any>(this.setHeureAvpEndpoint, params, cookies);
  }

}
